let shippingEstimatorOpener;
    try { shippingEstimatorOpener = document.querySelector('.shipping-bg-light-grey'); }
    catch(e) { console.error(e)}
let shippingEstimatorDestroyer = false;
    try { shippingEstimatorDestroyer = document.querySelector('.nm-easywholesale-form'); }
    catch(e) { console.error(e)}
//console.log("Destroyer is " + shippingEstimatorDestroyer);
if (shippingEstimatorOpener && !shippingEstimatorDestroyer) {
    try { shippingEstimatorOpener.setAttribute("open", ""); }
    catch(e) { console.error(e)}

let shippingEstimatorHider = shippingEstimatorOpener.querySelector('summary');
    try { shippingEstimatorHider.style.display = "none"; }
    catch(e) { console.error(e)}

let shippingEstimatorAutocomplete = shippingEstimatorOpener.querySelector('#address_zip');
    try { shippingEstimatorAutocomplete.setAttribute("autocomplete", "off"); }
    catch(e) { console.error(e)}
}
else if(shippingEstimatorDestroyer) {
    document.querySelector('.shipping-bg-light-grey').style.display = 'none';
}